import { AppShell } from '../components/AppShell';
import { useAuth } from '../lib/auth';

export function Account() {
  const { user } = useAuth();

  return (
    <AppShell>
      <h1 className="page-title mb-6">Mijn account</h1>

      <div className="card mb-5 max-w-xl">
        <h3 className="text-base font-semibold mb-3">Account-informatie</h3>
        <dl className="text-sm">
          <div className="flex py-2 border-b border-lightgrey">
            <dt className="text-secondary w-32">Naam</dt>
            <dd className="font-medium">{user?.displayName}</dd>
          </div>
          <div className="flex py-2 border-b border-lightgrey">
            <dt className="text-secondary w-32">E-mail</dt>
            <dd className="font-medium">{user?.email}</dd>
          </div>
          <div className="flex py-2">
            <dt className="text-secondary w-32">Rol</dt>
            <dd><span className="chip capitalize">{user?.role}</span></dd>
          </div>
        </dl>
      </div>

      <div className="card max-w-xl">
        <h3 className="text-base font-semibold mb-2">Inloggen</h3>
        <p className="text-sm text-secondary">
          Authenticatie verloopt via Recotex Toolbox (Microsoft 365 SSO). Wachtwoord
          wijzigen, naam aanpassen of accountbeheer doe je daar — niet hier.
        </p>
      </div>
    </AppShell>
  );
}
